(() => {
  class QuickShopSwatches extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    changeColor(el) {
      const quickShopContainer = el.closest('[data-quick-shop]')
      const quickShopClass = quickShopContainer.getAttribute('data-quick-shop')
      const quickShopItem = el.closest('[data-quick-shop-item]')
      const quickShopSizes = quickShopItem.querySelector('[data-quick-shop-sizes]')
      const quickShopMedia = quickShopItem.querySelector('[data-quick-shop-item-media]')
      const quickShopItemCaraousel = quickShopItem.querySelector('[data-quick-shop-item-carousel]')
      const activeSwatch = quickShopItem.querySelector('.swatch--active')
      const itemUrl = el.href.split('/products/')[1].split('?')[0]
      const imgheight = quickShopClass == 'quick-shop-carousel' ? '542' : '813'
      const imgWidth = quickShopClass == 'quick-shop-carousel' ? '400' : '600'

      if (activeSwatch) {
        activeSwatch.classList.remove('swatch--active')
      }

      el.classList.add('swatch--active')

      fetch(`/products/${itemUrl}?view=meta.json`)
        .then((res) => res.text())
        .then((response) => {
          response = JSON.parse(response)
          // update size selection, product title, price, links and images
          const discount = quickShopItem.querySelector('[data-quick-shop-item-discount]')
          const names = quickShopItem.querySelectorAll('[data-quick-shop-item-name]')
          const price = quickShopItem.querySelector('[data-quick-shop-item-price]')
          const badge = quickShopItem.querySelector('[data-quick-shop-item-stock]')
          let link = el.href

          const image = `
            <a href="${link}" class="${quickShopClass}__image-link" tabindex="-1" data-quick-shop-item-link>
              <figure class="${quickShopClass}__image-holder">
                <img src="${response.product.images[0].replace('.jpg', `_${imgWidth}x${imgheight}.jpg`)}" class="${quickShopClass}__image" data-quick-shop-image alt="image" height="${imgheight}" width="${imgWidth}">
                <figcaption class="visually-hidden" data-quick-shop-item-name>${response.product.title}</figcaption>
              </figure>
            </a>
          `.trim()
          const imageAlt = response.product.images.length > 1 ? `
            <a href="${link}" class="${quickShopClass}__image-link ${quickShopClass}__image-link--alternate" tabindex="-1" data-quick-shop-item-link>
              <figure class="${quickShopClass}__image-holder">
                <img src="${response.product.images[1].replace('.jpg', `_${imgWidth}x${imgheight}.jpg`)}" class="${quickShopClass}__image" data-quick-shop-image alt="image" height="${imgheight}" width="${imgWidth}">
                <figcaption class="visually-hidden" data-quick-shop-item-name>${response.product.title}</figcaption>
              </figure>
            </a>
          `.trim() : ''
          names.forEach((name) => {
            name.textContent = response.product.title
          })
          if (price) price.innerHTML = window.Shopify.formatMoney(response.product.price, window.theme.moneyFormat || '${{amount}}')
          if (discount) {
            let html = ''
            if (response.product.compare_at_price && response.product.compare_at_price > response.product.price) {
              const percent = Math.round(100 - ((parseFloat(response.product.price) / parseFloat(response.product.compare_at_price)).toFixed(4)) * 100) + '% off'
              html = `
                <div class="product-tile__meta product-tile__meta--sale">
                  <span class="product-tile__price">${window.Shopify.formatMoney(response.product.price, window.theme.moneyFormat || '${{amount}}')}</span>
                  <s class="product-tile__price-sale">${window.Shopify.formatMoney(response.product.compare_at_price, window.theme.moneyFormat || '${{amount}}')}</s>
                  <span class="product-tile__price product-tile__sale-price">
                    <span class="product-tile__price-savings">${percent}</span>
                  </span>
                </div>
              `
            } else {
              html = `<p class="quick-shop__price" data-quick-shop-item-price>${window.Shopify.formatMoney(response.product.price, window.theme.moneyFormat || '${{amount}}')}</p>`
            }
            discount.innerHTML = html
          }
          quickShopSizes.innerHTML = ''
          quickShopSizes.setAttribute('data-quick-shop-sizes', `${window.location.origin}/products/${response.product.handle}`)
          window.QuickShopPopulateVariants(quickShopSizes, response.product.options, response.product.variants)
          quickShopItem.setAttribute('data-quick-shop-item', link)
          if (quickShopItemCaraousel) {
            const divId = quickShopItemCaraousel.getAttribute('data-quick-shop-item-carousel')
            const carouselImageAlt = imageAlt == '' ? '' : `<div class="swiper-slide">${imageAlt}</div>`
            const carousel = `
              <div class="${quickShopClass}__item-carousel" data-quick-shop-item-carousel="${divId}"
                data-swiper='{
                  "a11y": {
                    "enabled": true,
                    "slideRole": "group"
                  },
                  "allowTouchMove": false,
                  "breakpoints": {
                    "768": {
                      "allowTouchMove": true
                    }
                  },
                  "loop": true,
                  "momentumVelocityRatio": 3,
                  "mousewheel": false,
                  "navigation": {
                    "nextEl": "[data-quick-shop-slide-buttun-next=quickshop-${divId}",
                    "prevEl": "[data-quick-shop-slide-buttun-prev=quickshop-${divId}"
                  },
                  "preloadImages": false,
                  "pagination": false,
                  "roundLengths": false,
                  "slidesPerGroup": 1,
                  "slidesPerView": 1,
                  "watchSlidesProgress": true
                }'>
                <button
                  class="quick-shop-slide-carousel__button quick-shop-slide-carousel__button--prev"
                  aria-label="Previous slide"
                  data-quick-shop-slide-buttun-prev="quickshop-${divId}"
                >
                  <svg aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" width="7" height="12" version="1.1" viewBox="0 0 7 12" style="pointer-events: none;">
                    <polyline fill="none" stroke="#231f20" stroke-miterlimit="10" points="6.455 11.605 .85 6 6.455 .395"/>
                  </svg>
                </button>
                <div class="swiper-wrapper">
                  <div class="swiper-slide">${image}</div>
                  ${carouselImageAlt}
                </div>
                <button
                  class="quick-shop-slide-carousel__button quick-shop-slide-carousel__button--next"
                  aria-label="Next slide"
                  data-quick-shop-slide-buttun-next="quickshop-${divId}"
                >
                  <svg aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" width="7" height="12" version="1.1" viewBox="0 0 7 12" style="pointer-events: none;">
                    <polyline fill="none" stroke="#231f20" stroke-miterlimit="10" points=".545 .395 6.15 6 .545 11.605"/>
                  </svg>
                </button>
              </div>
            `
            quickShopMedia.innerHTML = carousel
            if (typeof Swiper === 'function') {
              window.swipers()
            }
          } else {
            quickShopMedia.innerHTML = image + imageAlt
          }

          quickShopItem.querySelectorAll('.tcwl-heart').forEach(heart => heart.remove())
          quickShopItem.closest('[data-tcwl-done]')?.removeAttribute('data-tcwl-done')
          quickShopItem.querySelectorAll('[data-tcwl-done]').forEach(el => el.removeAttribute('data-tcwl-done'))

          // Inventory Badge
          let productStockStatus = 'out-of-stock'
          let productStockBadgeClass = 'hidden'
          let productStockBadgeText = ''
          var inventory = 0
          response.inventory.map((item) => { inventory += item.quantity })

          const veganEditUSId = '179654164564'
          const veganEditAUId = '211837550664'
          // Product Tile Badges badges
          let cleanTags = response.product.tags.map(tag => tag.toLowerCase())

          // Stock status badges
          if (inventory > 0 && !cleanTags.includes('limited stock')) {
            productStockStatus = 'in-stock'
          }

          if (cleanTags.includes('limited offer')) {
            productStockBadgeText = window.theme.strings.badges.flashSale
            productStockBadgeClass = 'quick-shop__badge--flash-sale'
          } else if (cleanTags.includes('selling fast')) {
            productStockBadgeText = window.theme.strings.badges.sellingFast
            productStockBadgeClass = 'quick-shop__badge--selling-fast'
          } else if (cleanTags.includes('limited stock')) {
            productStockBadgeText = window.theme.strings.badges.limitedStock
            productStockBadgeClass = 'quick-shop__badge--limited-stock'
          } else if (cleanTags.includes('princess polly tall')) {
            productStockBadgeText = window.theme.strings.badges.tall
            productStockBadgeClass = 'quick-shop__badge--tall'
          } else if (cleanTags.includes('princess polly petite')) {
            productStockBadgeText = window.theme.strings.badges.petite
            productStockBadgeClass = 'quick-shop__badge--petite'
          } else if (cleanTags.includes('princess polly curve')) {
            productStockBadgeText = window.theme.strings.badges.curve
            productStockBadgeClass = 'quick-shop__badge--curve'
          } else if (response.product_collection_ids.includes(veganEditUSId) || response.product_collection_ids.includes(veganEditAUId)) {
            productStockBadgeText = window.theme.strings.badges.vegan
            productStockBadgeClass = 'quick-shop__badge--vegan'
          }

          const badgeArr = response.product.tags.filter((tag) => tag.includes('Badge:') || tag.includes('badge:'))

          if (badgeArr.length) {
            const badgeText = badgeArr[0].split(':').pop()
            productStockBadgeText = badgeText
            productStockBadgeClass = ` quick-shop__badge--${this.handleize(badgeText)}`
          }

          badge.removeAttribute('class')
          badge.classList.add('quick-shop__badge')
          badge.classList.add(productStockBadgeClass)
          badge.textContent = productStockBadgeText
        })
        .catch((e) => {
          console.error(e)
        })
    }

    listeners() {
      this.els = this.querySelectorAll('[data-nosto-swatch]:not(.no-events)');

      this.els.forEach(el => {
        el.addEventListener('click', e => {
          e.preventDefault()
          this.changeColor(e.target);
        });
      });
    }

    init() {
      const buildSwatches = (entryTarget) => {
        const item = entryTarget.closest('[data-quick-shop-item]');

        // Only build swatches once
        if (item.classList.contains('nosto-swatches-built')) return;

        item.classList.add('nosto-swatches-built')

        let productRelativeURL = item.getAttribute('data-quick-shop-item')
        productRelativeURL = '/products/' + productRelativeURL.split('/products/')[1].split('?')[0]
        const nostoParameterAttr = item.closest('[nosto-parameter]')
        const nostoParameter = nostoParameterAttr ? '?' + nostoParameterAttr.getAttribute('nosto-parameter') : ''

        fetch(`${productRelativeURL}?view=swatches.json`)
          .then((res) => res.text())
          .then((data) => {
            data = JSON.parse(data)
            let swatchList = ''
            let activeClass = ''
            let productTitle = data.swatch_products.length > 0 ? `${data.swatch_products[0].product_title} ` : ''

            if (data.swatch_products.length > 0) {
              data.swatch_products.forEach((product) => {
                let link = product.url;

                if (routes.root_url != "/") {
                  link = link.replace('/', '');
                  link = `${routes.root_url}${link}`;
                }

                if (product.available || product.url === productRelativeURL) {
                  if (product.url === productRelativeURL) {
                    activeClass = ' swatch--active'
                  } else {
                    activeClass = ''
                  }
                  if (product.swatch_color) {
                    swatchList += `
                      <a href="${link}${nostoParameter}" data-nosto-swatch class="swatch${activeClass} swiper-slide" style="background-color: ${product.swatch_color};"></a>
                    `.trim()
                  } else {
                    swatchList += `
                      <a href="${link}${nostoParameter}" data-nosto-swatch class="swatch${activeClass} swiper-slide" style="background-image: url('${product.swatch_image}');"></a>
                    `.trim()
                  }
                }
              })
            }

            const sliderId = `quickshop-${Date.now()}`
            const swatchHTML = `
              <button type="button" class="swatch-swiper-button-prev" data-swatch-swiper-prev="${sliderId}" aria-label="Previous Slide">
                <svg aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" width="5" height="10" viewBox="0 0 5 10">
                  <path d="M5,10,2.058,5.17,5,0H2.964L0,5.17,2.964,10Z" opacity="0.7"/>
                </svg>
              </button>
              <div
                class="swiper"
                data-swiper='{
                  "a11y": {
                    "enabled": true,
                    "slideRole": "group"
                  },
                  "allowTouchMove": false,
                  "breakpoints": {
                    "375": {
                      "slidesPerGroup": 4,
                      "slidesPerView": 5,
                      "width": 115
                    },
                    "480": {
                      "slidesPerGroup": 5,
                      "slidesPerView": 6,
                      "width": 138
                    },
                    "1001": {
                      "slidesPerGroup": 7,
                      "slidesPerView": 7,
                      "width": 168
                    },
                    "1440": {
                      "slidesPerGroup": 8,
                      "slidesPerView": 8,
                      "width": 192
                    }
                  },
                  "centeredSlides": false,
                  "height": 24,
                  "loop": false,
                  "observeParents": true,
                  "observer": true,
                  "mousewheel": false,
                  "navigation": {
                    "nextEl": "[data-swatch-swiper-next=${sliderId}]",
                    "prevEl": "[data-swatch-swiper-prev=${sliderId}]"
                  },
                  "pagination": false,
                  "roundLengths": false,
                  "slidesPerGroup": 3,
                  "slidesPerView": 4,
                  "watchOverflow": true,
                  "watchSlidesProgresress": true,
                  "watchSlidesVisibility": true,
                  "width": 92
                }'
              >
                <div class="product-tile__swatches swiper-wrapper" data-product-tile-swatches="tile">
                  ${swatchList}
                </div>
              </div>
              <button type="button" class="swatch-swiper-button-next" data-swatch-swiper-next="${sliderId}" aria-label="Next Slide">
                <svg aria-hidden="true" role="presentation" xmlns="http://www.w3.org/2000/svg" width="5" height="10" viewBox="0 0 5 10">
                  <path d="M0,0l2.942,4.83L0,10h2.036l2.964-5.17L2.036,0H0Z" opacity="0.7"/>
                </svg>
              </button>
            `.trim()

            const swatches = document.createElement('div')
            swatches.classList.add('swatches')
            swatches.setAttribute('role', 'region')
            swatches.setAttribute('aria-roledescription', 'carousel')
            swatches.setAttribute('aria-label', `${productTitle}Swatches`)
            swatches.innerHTML = swatchHTML

            this.append(swatches)

            if (typeof Swiper === 'function') {
              window.swipers()
            } else {
              window.loadSwiper();
            }

            requestAnimationFrame(() => {
              this.listeners();
            });
          })
          .catch((e) => {
            console.error(e)
          })
      }

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) {
            buildSwatches(entry.target);
            observer.unobserve(entry.target)
          }
        })
      })

      observer.observe(this)
    }
  }

  if (!customElements.get('quick-shop-swatches')) {
    customElements.define('quick-shop-swatches', QuickShopSwatches);
  }
})();
